module.exports = __webpack_public_path__ + "img/chongwu.4bef1e5a.png";